import { render, staticRenderFns } from "./CourseStages.vue?vue&type=template&id=7300046a&scoped=true"
import script from "./CourseStages.vue?vue&type=script&lang=js"
export * from "./CourseStages.vue?vue&type=script&lang=js"
import style0 from "./CourseStages.vue?vue&type=style&index=0&id=7300046a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7300046a",
  null
  
)

export default component.exports